import { Box } from '@common-ui-library/atom';
import { UsersIcon, useI18n } from '@common-ui-library/shared';
import { Business } from '@mui/icons-material';
import React from 'react';
import { APP_NAME } from '../Utils/utils';
import { Navigate, Route, Routes } from 'react-router-dom';
import UserManagementTableWrapper from './FrameComponents/UMEntityTable';
import { NotFoundPage } from '../EleosAdminPortal/NotFoundPage';

export const useUserManagementNavigation = () => {
  const { t } = useI18n();
  return [
    {
      title: t('navigation.sites'),
      segment: `${APP_NAME}/sites/`,
      pattern: `sites{/:entityId}*`,
      icon: <Business sx={{ '& path': { fill: (theme) => theme.palette.primary.main } }} />,
    },
    {
      title: t('navigation.users'),
      segment: `${APP_NAME}/providers/`,
      pattern: `providers{/:entityId}*`,
      icon: <UsersIcon />,
    },
  ];
};

export const UserManagementDashboardContent = () => (
  <Box sx={{ py: 4, px: 3 }}>
    <Routes>
      <Route
        path="/"
        element={<Navigate to="sites" replace />}
      />
      <Route
        path={`:userManagementEntity/:entityId?`}
        element={<UserManagementTableWrapper />}
      />
      <Route
        path="*"
        element={<NotFoundPage />}
      />
    </Routes>
  </Box>
);

